import React, { useMemo } from 'react';
import { Button, Chip, Typography, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import StyledBox from 'views/rebranded-module/common/components/UI/NewMainWidget/NewVehicalCounter/NewVehicalCounter.styles';
import { RENTAL_WIDGET_FIELDS, ERRORS_PREFIX } from 'lib/utils/mainWidgetConstants';
import Typography500 from 'views/common/components/UI/Typography500';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';

type MotorcycleCountOption = {
  number: string | number;
  discount?: string;
};

const NewVehicalCounter = (props) => {
  const {
    handleFormDataChange,
    formData,
    motorcycleList,
    disableVehicleCount,
    errors,
    className,
  } = props;

  const cmsData = useContent('NewMainWidgetComponent');
  const count = formData.reservation?.vehicles_count || 1;

  const savedValue = useMemo(
    () => (motorcycleList as MotorcycleCountOption[]).find(
      (motorcycle) => +motorcycle.number === count
        || (+motorcycle.number === 6 && count >= 6),
    )?.discount,
    [motorcycleList, count],
  );

  const handleIncrease = () => {
    if (!disableVehicleCount) {
      handleFormDataChange(RENTAL_WIDGET_FIELDS.VEHICLES_COUNT, +count + 1);
    }
  };

  const handleDecrease = () => {
    if (count > 1 && !disableVehicleCount) {
      handleFormDataChange(RENTAL_WIDGET_FIELDS.VEHICLES_COUNT, +count - 1);
    }
  };

  return (
    <StyledBox className={className} disabled={disableVehicleCount}>
      <Box display="flex" alignItems="center" gap={1.25} >
        <Box className="VCCountNum">
          <Typography500  variant="body2">{count}</Typography500>
        </Box>

        <Typography500 variant="body2" className="VCLabel">
          {cmsData.vehiclesLabel}
        </Typography500>
        <Button
          color="secondary"
          className="VCBtn"
          variant="outlined"
          data-testid="rider-count-decrease"
          onClick={handleDecrease}
          disabled={count === 1 || disableVehicleCount}
        >
          <RemoveIcon fontSize="small" />
        </Button>
        <Button
          color="secondary"
          className="VCBtn"
          variant="outlined"
          data-testid="rider-count-increase"
          onClick={handleIncrease}
          disabled={disableVehicleCount}
        >
          <AddIcon fontSize="small" />
        </Button>
        {savedValue && (
          <Chip
            className="VCDiscountChip"
            label={interpolateString(cmsData.saveUpTo, { value: savedValue })}
            color="primary"
          />
        )}
      </Box>
      {errors[`${ERRORS_PREFIX}${RENTAL_WIDGET_FIELDS.VEHICLES_COUNT}`] && (
        <Typography color="error" variant="caption" component="p">
          {errors[`${ERRORS_PREFIX}${RENTAL_WIDGET_FIELDS.VEHICLES_COUNT}`]}
        </Typography>
      )}
    </StyledBox>
  );
};

export { NewVehicalCounter };